module.exports = __webpack_public_path__ + "static/pitch-using-prototypes-cb4013c37b4f4256bf0b0878a9a13534.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/pitch-using-prototypes.png
// module id = 2695
// module chunks = 157636680307020